import { Box, Card, Chip, Icon, IconButton, Tab, Tabs } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { get } from "utils/WebService";
import CadastroBasico from "./tabs/CadastroBasico";
import Contratos from "./tabs/Contratos";
import Historico from "./tabs/Historico";
import Acordos from "./tabs/Acordos";
import Juridico from "./tabs/Juridico";
import Honorarios from "./tabs/Honorarios";
import HeaderDevedor from "./tabs/HeaderDevedor";

export default function BaseDeDadosCreateEdit({ recordId, closeCreateEdit, isJuridico, isViewOnly }) {
    const [tabValue, setTabValue] = useState(1);
    const [pendingContratos, setPendingContratos] = useState([]);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const formRef = useRef();

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const [hasProcesso, setHasProcesso] = useState(false);

    useEffect(() => {
        if (recordId) {
            get(`/contratos/list/${recordId}`)
                .then(res => {
                    if (res && res.some(c => c.idProcesso)) {
                        setHasProcesso(true);
                    }
                })
                .catch(err => console.error("Erro ao verificar processos:", err));

            get(`/devedor/by-id/${recordId}`)
                .then(res => {
                    if (res && res.nome) {
                        sessionStorage.setItem('activeDevedorId', recordId);
                        sessionStorage.setItem('activeDevedorNome', res.nome);
                        window.dispatchEvent(new Event('sessionStorageUpdate'));
                    }
                })
                .catch(err => console.error("Erro ao carregar detalhes do devedor:", err));
        } else {
            sessionStorage.removeItem('activeDevedorId');
            sessionStorage.removeItem('activeDevedorNome');
            window.dispatchEvent(new Event('sessionStorageUpdate'));
        }

        return () => {
            sessionStorage.removeItem('activeDevedorId');
            sessionStorage.removeItem('activeDevedorNome');
            window.dispatchEvent(new Event('sessionStorageUpdate'));
        };
    }, [recordId]);

    return (
        <Card id="base-dados-info">
            <Box display="flex" alignItems="center" px={2} pt={2} pb={isViewOnly ? 1 : 2}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 2 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                {recordId && (
                    <MDBox sx={{ flexGrow: 1 }}>
                        <HeaderDevedor recordId={recordId} />
                    </MDBox>
                )}
            </Box>

            <MDBox sx={{ width: '100%', px: 2, mb: 8 }}>
                <MDBox sx={{ borderBottom: 1, width: "100%", borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleChange} aria-label="base-dados-tabs">
                        <Tab label="Cadastro Básico" value={1} sx={{ fontSize: 12 }} />
                        <Tab label="Contratos" value={2} sx={{ fontSize: 12 }} />
                        {recordId && <Tab label="Honorários" value={6} sx={{ fontSize: 12 }} />}
                        {recordId && <Tab label="Histórico" value={3} sx={{ fontSize: 12 }} />}
                        {recordId && <Tab label="Acordos" value={4} sx={{ fontSize: 12 }} />}
                        {recordId && hasProcesso && <Tab label="Jurídico" value={5} sx={{ fontSize: 12 }} />}
                    </Tabs>
                </MDBox>

                <MDBox mt={3}>
                    <div role="tabpanel" hidden={tabValue !== 1} id={`tab-1`}>
                        <CadastroBasico formRef={formRef} recordId={recordId} isJuridico={isJuridico} closeCreateEdit={closeCreateEdit} isViewOnly={isViewOnly} pendingContratos={pendingContratos} />
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 2} id={`tab-2`}>
                        {tabValue === 2 && <Contratos formRef={formRef} recordId={recordId} isViewOnly={isViewOnly} pendingContratos={pendingContratos} setPendingContratos={setPendingContratos} changeTab={setTabValue} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 6} id={`tab-6`}>
                        {tabValue === 6 && <Honorarios formRef={formRef} recordId={recordId} isViewOnly={isViewOnly} pendingContratos={pendingContratos} setPendingContratos={setPendingContratos} changeTab={setTabValue} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 3} id={`tab-3`}>
                        {tabValue === 3 && <Historico recordId={recordId} isViewOnly={isViewOnly} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 4} id={`tab-4`}>
                        {tabValue === 4 && <Acordos recordId={recordId} isViewOnly={isViewOnly} changeTab={setTabValue} />}
                    </div>
                    <div role="tabpanel" hidden={tabValue !== 5} id={`tab-5`}>
                        {tabValue === 5 && hasProcesso && <Juridico recordId={recordId} />}
                    </div>
                </MDBox>
            </MDBox>
        </Card>
    );
}
